import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { MobileMenuTypesEnum } from 'common/components/entities/Menu/enums/MobileMenuTypesEnum'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createMenu(parentId: string, masterBlockId?: MasterBlockId) {
  const menu: MenuInterface = {
    ...generateBaseEntity(EntityTypeEnum.Menu, parentId, masterBlockId),
    alignSelf: 'flex-start',
    mobileAlignSelf: 'flex-start',
    burgerAlignSelf: 'flex-end',
    spacing: 13,
    fontSize: 26,
    color: 'rgba(74, 74, 74, 1)',
    subMenuColor: 'rgba(74, 74, 74, 1)',
    subMenuBackgroundColor: 'rgba(255, 255, 255, 1)',
    activeColor: 'rgba(167, 154, 122, 1)',
    sideMenuBackgroundColor: 'rgba(255, 255, 255, 1)',
    burgerIconColor: 'rgba(74, 74, 74, 1)',
    mobileMenuType: MobileMenuTypesEnum.side,
    burger: true,
    menuItems: [
      { text: '', link: '', subMenuItems: [], subMenuOpen: false },
      { text: '', link: '/contacts', subMenuItems: [], subMenuOpen: false },
    ],
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  }

  return menu
}
